import FallbackText from './FallbackText';

export default FallbackText;
